// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a2e92d21","447":"c415c9da","861":"a65dc8ef"}[chunkId] + ".chunk.js";
};